export interface PricingPlan {
  name: string
  tier: "starter" | "premium" | "ultimate"
  price: number
  period: string
  description: string
  features: string[]
  highlighted: boolean
  cta: string
  coinsPerMonth: number
}

export const pricingPlans: PricingPlan[] = [
  {
    name: "Starter",
    tier: "starter",
    price: 12.99,
    period: "month",
    description: "Unlock the core Pleasur.ai experience",
    features: [
      "Unlimited messages",
      "1,500 coins/month",
      "AI image generation (10 coins each)",
      "Voice notes (10 coins each)",
      "Create your own girlfriend",
      "Unlimited 18+ text messages",
      "Spicy 18+ messages",
      "Buy additional coins",
    ],
    highlighted: false,
    cta: "Get Starter",
    coinsPerMonth: 1500,
  },
  {
    name: "Standard",
    tier: "premium",
    price: 27.99,
    period: "month",
    description: "The full experience with premium features",
    features: [
      "Everything in Starter",
      "5,000 coins/month",
      "Phone calls (50 coins/min)",
      "Buy additional coins",
    ],
    highlighted: true,
    cta: "Go Standard",
    coinsPerMonth: 5000,
  },
  {
    name: "Ultimate",
    tier: "ultimate",
    price: 49.99,
    period: "month",
    description: "Everything, without limits",
    features: [
      "Everything in Standard",
      "10,000 coins/month",
      "Early access to features",
      "Buy additional coins",
    ],
    highlighted: false,
    cta: "Go Ultimate",
    coinsPerMonth: 10000,
  },
]

export const pricingFaqs = [
  {
    question: "Can I try Pleasur.ai before subscribing?",
    answer:
      "Yes! You can explore the platform with limited access before subscribing. Free users get 5 messages per day and 2 AI images per month to try out the experience. To unlock unlimited messages, voice notes, phone calls, and more, choose a plan that fits your needs.",
  },
  {
    question: "Can I cancel anytime?",
    answer:
      "Absolutely. There are no long-term contracts or cancellation fees. You can cancel your subscription at any time from your account settings, and you'll continue to have access to your paid features until the end of your current billing period.",
  },
  {
    question: "How does the coin system work?",
    answer:
      "Subscribers receive monthly coins based on their plan (Starter: 1,500, Standard: 5,000, Ultimate: 10,000). Coins are used for premium features like AI image generation (10 coins), voice notes (10 coins), and phone calls (50 coins/min). Messages are unlimited for all subscribers. Need more? Subscribers can purchase additional coin packs anytime.",
  },
  {
    question: "Is my data private and secure?",
    answer:
      "Yes. All conversations are encrypted end-to-end and never used to train models without your explicit consent. We don't sell user data to third parties. Ultimate plan users also have the option to enable zero data retention for complete privacy.",
  },
  {
    question: "Can I upgrade or downgrade my plan?",
    answer:
      "You can switch between plans at any time. When upgrading, you'll get immediate access to new features and be charged the prorated difference. When downgrading, the change takes effect at the start of your next billing cycle.",
  },
  {
    question: "Do you offer refunds?",
    answer:
      "We offer a 7-day money-back guarantee for first-time subscribers. If you're not satisfied within your first week, contact our support team for a full refund. After the initial period, refunds are handled on a case-by-case basis.",
  },
]
